import React from 'react';
import { Icon } from '@reverse-hr/pattern-library';
import { useTranslation } from 'react-i18next';
import { MotivationIcons } from '@app/constants/candidate';

const MotivationToChange = props => {
  const { candidateMotivationToChange } = props;
  const { t } = useTranslation();

  const renderMotivationToChange = () =>
    candidateMotivationToChange ? (
      <>
        <Icon
          modifier=""
          size={20}
          name={MotivationIcons[candidateMotivationToChange]}
        />
        <p className="c-app-showcase__motivation-text capitalize">
          {t(
            `showcase.motivationToChangeValues.${candidateMotivationToChange}`,
          )}
        </p>
      </>
    ) : null;

  return (
    <td className="c-app-showcase__cell c-app-showcase__cell--center-aligned">
      <div className="c-app-showcase__motivation">
        {renderMotivationToChange()}
      </div>
    </td>
  );
};

export default MotivationToChange;
